import {SortedModel} from "../../models/general/search.criteria";

export const sortedGrid: SortedModel[] = [{name: "insertDate", direction: "desc"}];
export const pageSizeLarge: number = 20;
export const pageSizeMedium: number = 10;
export const pageSizeSmall: number = 5;
export const pageOptionsLarge: number[] = [10,20,50,100];
export const pageOptionsMedium: number[] = [10,15,20,25];
export const pageOptionsSmall: number[] = [5,10,15,20];